<template>
  <div class="login-container content-bg" :class="{
    isMobile: isMobile()
  }">
    <div class="sys-max-width">
      <div class="main flex">
        <div class="common left"></div>

        <div class="common right">
          <div class="title">欢迎登录</div>

          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            class="login-form"
            autocomplete="on"
            label-position="left"
          >
            <!-- 手机号登录 -->
            <div class="mobile-login">
              <el-form-item prop="phone">
                <el-input
                  @input="mobileOnlyNumber"
                  ref="phone"
                  v-model="loginForm.phone"
                  placeholder="请输入手机号"
                  name="phone"
                  type="text"
                  tabindex="1"
                  autocomplete="on"
                  :validate-event="false"
                />
              </el-form-item>

              <el-form-item class="password-item" prop="password">
                <el-input
                  :key="passwordType"
                  ref="password"
                  v-model="loginForm.password"
                  :type="passwordType"
                  placeholder="请输入密码"
                  name="password"
                  tabindex="2"
                  autocomplete="on"
                  @keyup.enter.native="handleLogin"
                  :validate-event="false"
                />
              </el-form-item>

              <el-form-item class="code-item" prop="checkCode">
                <el-input
                  v-model.trim="loginForm.checkCode"
                  placeholder="请填写验证码"
                  :validate-event="false"
                  tabindex="3"
                />

                <div class="img-box" @click="reGetQrCodeHandle">
                  <img class="img-common" :src="qrCodeImgUrl" />
                </div>
              </el-form-item>

              <div class="read-item flex items-center">
                <div class="check-text flex">
                  <div class="text">阅读</div>
                  <div @click="$router.push({name: 'help'})" class="link">《网站注册服务条款》</div>
                </div>
              </div>
            </div>

            <el-button
              class="btn-submit"
              :loading="loading"
              tabindex="4"
              type="primary"
              style="width:100%;"
              @click.native.prevent="handleLogin"
            >立即登录</el-button>

            <div class="bottom-registory-box flex justify-between">
              <div class="flex items-center">
                <div class="text">还没有账号？</div>
                <el-button tabindex="5" type="text" @click="$router.push({name: 'registry'})">免费注册</el-button>
              </div>
              
              <el-button tabindex="6" type="text" @click="$router.push({name: 'resetPassword'})">忘记密码</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { isMobile } from '@/utils/index'
import { loginFetch } from '@/api/login'
import { setToken, setMobile, setAccount, setAva, setState } from '@/utils/auth'
import eventBus from '@/utils/bus'
import jsSHA from "jssha"
import imgQrCodeMixins from '@/mixins/imgQrCode'

const checkMobile = (rule, value, callback) => {
  if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
    return callback(new Error('您输入的手机号不合法'))
  }

  callback()
}

const validatePassword = (rule, value, callback) => {
  if (value.length === 0) {
    callback(new Error('请输入密码'));
  } else if (value.length > 30 || value.length < 1) {
    callback(new Error('当前密码格式不正确'));
  } else {
    callback();
  }
};

export default {
  mixins: [imgQrCodeMixins],
  data() {
    return {
      loginForm: {
        phone: '',
        password: '',

        checkCode: ''
      },
      loginRules: {
        phone: [{ required: true, trigger: 'blur', validator: checkMobile }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        checkCode: [{ required: true, message: '验证码为必填项', trigger: 'blur' }],
      },
      passwordType: 'password',
      loading: false
    }
  },
  mounted() {
    if (this.loginForm.phone === '') {
      this.$refs.phone.focus();
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus();
    }
  },
  methods: {
    isMobile,
    mobileOnlyNumber(value) {
      this.loginForm.phone = value.replace(/[^\d]/g, ""); 
    },
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true

          // 加密
          const shaObj = new jsSHA("SHA-1", "TEXT", { encoding: "UTF8" })
          shaObj.update(this.loginForm.password)

          try {
            const { token, mobile, userName, avatar, state } = await loginFetch({
              nickName: this.loginForm.phone,
              password: shaObj.getHash("HEX"),
              type: 1,
              check_code_raw: this.code, // 随机数验证码
              check_code_value: this.loginForm.checkCode // 图片上的值
            })

            if (token) { // 登录成功
              setToken(token)
              setAccount(userName)
              setMobile(mobile)
              setAva(avatar)
              setState(state)

              this.loading = false

              // eventBus
              eventBus.$emit('after-login', {
                avatar
              })

              // 跳转到其他
              // const { redirect } = this.$route.query

              // if (redirect) {
              //   this.$router.push({
              //     path: redirect
              //   })
              // } else { // 跳转到首页
              //   this.$router.push({
              //     name: 'index'
              //   })
              // }

              this.$router.push({
                name: 'index'
              })
            } else {
              this.$message.error('登录失败')
              this.loading = false
            }
          } catch (error) {
            this.loading = false
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss">
.login-container {

  &.isMobile {
    .sys-max-width {
      padding: 0;
      .main {
        display: block;
        background-color: #F4F7FC;

        .common.left {
          display: none;
        }

        .common.right {
          padding: 0 2.5rem 4rem; 

          .title {
            margin-top: 0;
            padding-top: 30px;
          }
        }
      }
    }
  }


  .sys-max-width {
    padding: 80px 60px 77px;
    .main {
      background: #fff;
      .common {
        flex: 0 0 50%;
        &.left {
          width: 496px;
          height: 445px;
          background: url(~@/assets/login-bg.png) no-repeat;
          background-size: 100% 100%;
        }

        &.right {
          padding: 8px 53px;

          .title {
            margin-top: 30px;
            margin-bottom: 30px;
            text-align: center;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #596270;
            line-height: 24px;
          }

          .mobile-login {

          }
        }
      }

      
    }

    .read-item {
      margin-bottom: 37px;

      .text {
        color: #333;
      }

      .link {
        cursor: pointer;
        color: $primary;
      }

      .check-text {
        // margin-left: 11px;
      }

      
    }

    .bottom-registory-box {
      color: #333333;
      font-size: 12px;

      .el-button {
        font-size: 12px;
      }
    }

    .code-item {
      margin-bottom: 22px;
      .el-form-item__content {
        display: flex;
        justify-content: space-between;
      }

      .img-box {
        cursor: pointer;
        width: 180px;
        height: 40px;
        margin-left: 30px;
        border: 1px solid #F4F7FC;
      }

      // .el-button {
      //   width: 0px;
      //   margin-left: 10px;
      // }
    }
  }
}
</style>
